var _clipPath, _linearGradient, _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingCitizen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "citizen-web",
    viewBox: "-3 3 38 38",
    width: "128px",
    height: "128px",
    style: {
      background: "none",
      shapeRendering: "crispedges",
      imageRendering: "-moz-crisp-edges"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "i-loading"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#000000",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopOpacity: 0
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c-loading"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 11,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 1,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 15,
    width: 1,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 29,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 29,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 29,
    width: 1,
    height: 1
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: 8
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "red;orange;yellow;green;blue;violet;red;",
    dur: "1s",
    repeatCount: "indefinite"
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5,
    cy: 33,
    rx: 6,
    ry: 2,
    fill: "url(#i-loading)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "rx",
    dur: "1.3s",
    values: "9;7;9",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0; 0.5; 1",
    keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#8)",
    clipPath: "url(#c-loading)",
    id: "r"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "XML",
    attributeName: "transform",
    type: "translate",
    values: "0,.5;0,-.5;0,.5",
    repeatCount: "indefinite",
    dur: "1.3s",
    calcMode: "spline",
    keyTimes: "0; 0.5; 1",
    keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 13,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 14,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 14,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 15,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 15,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 16,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 16,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 17,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 17,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 18,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 18,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 19,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 19,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 20,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 20,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 21,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 21,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 10,
    y: 22,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 21,
    y: 22,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1,
    x: 12,
    y: 23,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 11,
    y: 24,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 21,
    y: 24,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 25,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 13,
    y: 25,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 19,
    y: 25,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 25,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 26,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 26,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 26,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 26,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 10,
    y: 27,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 27,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 27,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 22,
    y: 27,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    x: 10,
    y: 28,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    x: 20,
    y: 28,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 29,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 29,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 11,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 12,
    y: 30,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 15,
    y: 30,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 17,
    y: 30,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    x: 20,
    y: 30,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    x: 12,
    y: 31,
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    x: 17,
    y: 31,
    fill: "#000001"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingCitizen);
export default __webpack_public_path__ + "static/media/loading-citizen.38a24aad1dba7047af3e1fd44a26218d.svg";
export { ForwardRef as ReactComponent };